import CheckCircleGold from "~/assets/check-circle-gold.svg";
import useHandlers from "~/hooks/useHandlers";

import "./ProgressBarMobile.css";

const ProgressBarMobile = ({ selectedCapsules, data }) => {
  const { progressDiscount } = useHandlers({ selectedCapsules });

  const { totalItems, clonedDiscountTier: discountTier } = progressDiscount(data);
  console.log("selectedCapsules", selectedCapsules);
  console.log("totalItems", totalItems);
  console.log("discountTier", discountTier);

  return (
    <div className="progress-bar-mobile-container">
      {totalItems < 8 ? (
        <span className="progress-bar-mobile-title">
          ADD {8 - totalItems} MORE {`${8 - totalItems === 1 ? "PRODUCT" : "PRODUCTS"}`} TO GET{" "}
          {discountTier[8]}% OFF
        </span>
      ) : (
        <span className="progress-bar-mobile-title">YOU'VE UNLOCKED {discountTier[8]}% OFF</span>
      )}

      <div className="progress-bar-mobile-blocks">
        {Array.from({ length: 8 }, (_, i) => (
          <div
            key={i}
            className={`progress-bar-mobile-block ${
              i < totalItems ? "progress-bar-mobile-block-filled" : ""
            }`}
          />
        ))}
      </div>

      <div className="progress-bar-mobile-selected-capsules-wrapper">
        <CheckCircleGold />
        {totalItems > 0 && (
          <span className="item-count">
            <span className="item-current-count">{totalItems}</span>
            {`${totalItems === 1 ? "item" : "items"}`}
          </span>
        )}
        {totalItems > 1 && <span className="discount">-{discountTier[totalItems]}%</span>}
      </div>
    </div>
  );
};

export default ProgressBarMobile;
